module.exports = __webpack_public_path__ + "img/DSC_0056.4e449cb4.jpg";